module.exports = __webpack_public_path__ + "static/assets/401e77627138095be1e94a9cd76f6f71.svg";